"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPaymentMethod = void 0;
exports.EPaymentMethod = {
    CHEQUE: "cheque",
    VIREMENT: "virement",
    PRELEVEMENT: "prelevement",
    CREDIT: "credit",
    CREDIT_CONSORTIUM: "credit_consortium",
};
